import React from 'react';
import Typography from '@material-ui/core/Typography';
import styles from '../../constants/stylesDefault';
import Spinner from './Spinner';

const Loader = () =>
  <div style={styles.center}>
    <Spinner/>
    <Typography variant="h6" gutterBottom>Chargement</Typography>
  </div>;

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Layout/Loader.jsx